var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import uuid from "uuid/v4";
import CampaignService from "../../../../Services/Campaign.service";
import SearchField from "../../../Form/SearchField";
import { CampaignSearch } from "../../Campaign/CampaignSearch";
export const ENROLL_IN_CAMPAIGN_GET_CRITERIA = (formState, { exportNodeId, pipelineId }) => {
    const PERSON_LOADER_DELEGATE_ID = uuid();
    const personLoaderDelegate = {
        id: PERSON_LOADER_DELEGATE_ID,
        type: "PersonLoader",
        criteria: {
            personId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
        },
    };
    const OPPORTUNITY_LOADER_DELEGATE_ID = uuid();
    const opportunityLoaderDelegate = {
        id: OPPORTUNITY_LOADER_DELEGATE_ID,
        type: "OpportunityLoader",
        criteria: {
            subjectId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
            pipelineId: {
                isReference: false,
                value: pipelineId,
            },
        },
    };
    return {
        delegates: [personLoaderDelegate, opportunityLoaderDelegate],
        criteria: {
            opportunityId: {
                isReference: true,
                workflowNodeReferenceId: OPPORTUNITY_LOADER_DELEGATE_ID,
                propertyName: "opportunityId",
            },
            campaignId: {
                value: formState.campaign.id,
                isReference: false,
            },
        },
    };
};
export const ENROLL_IN_CAMPAIGN_GET_FORM_STATE = (criteria) => __awaiter(void 0, void 0, void 0, function* () {
    return {
        campaign: yield CampaignService.get(criteria.campaignId.value),
    };
});
const EnrollInCampaignWorkflowNodeDefinitionForm = ({ name, virtualizedAppName, }) => {
    return (_jsx(_Fragment, { children: _jsx(SearchField, { name: name + ".campaign", label: "Campaign", required: true, as: (provided) => (_jsx(CampaignSearch, Object.assign({}, provided, { isStarted: true, isStopped: false, virtualizedAppName: virtualizedAppName, 
                // @ts-expect-error - TS2322 - Type '{ isStarted: true; virtualizedAppName: string; lite: true; placeholder: string | null | undefined; hasError: boolean; errorMessage: string | null | undefined; disabled: boolean | null | undefined; "aria-label": string; }' is not assignable to type 'IntrinsicAttributes & { id?: string | null | undefined; name?: string | null | undefined; "aria-label": string; formErrors?: any; hasError?: boolean | null | undefined; ... 14 more ...; minNumSearchCharacters?: number | ... 1 more ... | undefined; } & CampaignSearchArgs'.
                lite: true }))) }) }));
};
export default EnrollInCampaignWorkflowNodeDefinitionForm;
